import { useCallback, useContext } from 'react';
import { useDispatch } from 'react-redux';
import useAxiosPrivate from './useAxiosPrivate';
import useAuth from './useAuth';
import ErrorContext from '../Context/ErrorContext';
import { addSubCategories } from '../redux/productSlice';
import { getSubCategories } from '../api/products';

/**
 * Shared hook to fetch subcategories and dispatch to Redux.
 * Used by HomeScreen and ProductList for DRY subcategory refresh.
 */
const useFetchSubCategories = () => {
  const axiosprivate = useAxiosPrivate();
  const { auth } = useAuth();
  const dispatch = useDispatch();
  const { handleError } = useContext(ErrorContext);

  return useCallback(async (): Promise<boolean> => {
    try {
      const response = await getSubCategories(axiosprivate, auth);
      if (response?.data?.status === 200) {
        dispatch(addSubCategories(response?.data?.data));
        return true;
      }
      handleError(
        response?.data?.message || 'Failed to fetch subcategories',
        'error',
        true,
      );
      return false;
    } catch (error: any) {
      handleError(
        error?.message || 'Failed to fetch subcategories',
        'error',
        true,
      );
      return false;
    }
  }, [axiosprivate, auth, dispatch, handleError]);
};

export default useFetchSubCategories;
